import { useEffect } from 'react'
import useStore from '../store'

export default function useCarpoolOrdersSubscription() {
  const subscribeToCarpoolOrders = useStore((state) => state.subscribeToCarpoolOrders)
  const consumer = useStore((state) => state.consumer)

  useEffect(() => {
    if (!consumer) return
    const subscription = subscribeToCarpoolOrders()
    return () => subscription.unsubscribe()
  }, [consumer])
}
